module.exports = __webpack_public_path__ + "static/aboutPhones-7980d1cf0e3a77d49460a4109889b6e7.png";